import React from 'react';
import { ProgressBar, Nav } from 'react-bootstrap';

/**
 * WizardStepIndicator - Shows current progress through the wizard steps.
 * Displays a progress bar and clickable step names.
 */
const WizardStepIndicator = ({ currentStep, totalSteps, stepNames, stepCompletion }) => {
  const progressPercent = Math.round(((currentStep - 1) / (totalSteps - 1)) * 100);

  return (
    <div className="wizard-step-indicator">
      <ProgressBar
        now={progressPercent}
        label={`${progressPercent}%`}
        variant="primary"
        className="mb-2"
        style={{ height: '8px' }}
      />
      <Nav variant="pills" className="flex-wrap justify-content-center gap-1">
        {stepNames.map((name, index) => {
          const stepNumber = index + 1;
          const isComplete = !!stepCompletion[stepNumber];
          const isCurrent = stepNumber === currentStep;
          const isFuture = stepNumber > currentStep && !isComplete;

          let variant = 'outline-secondary';
          if (isCurrent) variant = 'primary';
          else if (isComplete) variant = 'success';

          return (
            <Nav.Item key={stepNumber}>
              <Nav.Link
                className={`px-2 py-1 small ${isCurrent ? 'active' : ''}`}
                style={{
                  fontSize: '0.75rem',
                  opacity: isFuture ? 0.5 : 1,
                  backgroundColor: isCurrent ? '#0d6efd' : isComplete ? '#198754' : 'transparent',
                  color: (isCurrent || isComplete) ? '#fff' : '#6c757d',
                  border: `1px solid ${isCurrent ? '#0d6efd' : isComplete ? '#198754' : '#dee2e6'}`,
                  borderRadius: '4px'
                }}
                disabled={isFuture}
              >
                {stepNumber}. {name}
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
    </div>
  );
};

export default WizardStepIndicator;
